import { DOCUMENT } from '@angular/common'
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { CodeService } from '@core/code.service'
import { StoreService } from '@core/store.service'
import { SpinnerPNOComponent, SpinnerB4RComponent, SpinnerSHYPSComponent, SpinnerBINSComponent } from "@core/spinner.component";

@Injectable()
export class StageService {
   console: boolean = false
   logPrefix: string = '@core - ' + this.constructor.name

   public spinner: MatDialogRef<SpinnerPNOComponent | SpinnerB4RComponent>;
   public spinReqShow: number = 0
   public spinReqClose: number = 0

   public spinnerTypes: string[] = ['PNO', 'B4R', 'SHYPS', 'BINS'];
   public spinnerType: string = 'PNO'

   public layoutThemes: any = {}
   public layoutThemeName: string = null

   private renderer: Renderer2

   constructor(
      public code: CodeService,
      private store: StoreService,
      private router: Router,
      public dialog: MatDialog,
      @Inject(DOCUMENT) document,
      rendererFactory: RendererFactory2
   ) {
      this.renderer = rendererFactory.createRenderer(null, null)
   }

   //-- THEME --//

   addLayoutTheme(themeName: string, themeParams: any) {
      if (themeName && themeParams) {
         this.layoutThemes[themeName] = themeParams

         return true
      }
      return false
   }

   getLayoutTheme(themeName: string) {
      return this.hasLayoutTheme(themeName) ? this.layoutThemes[themeName] : null
   }

   hasLayoutTheme(themeName: string) {
      return themeName && this.layoutThemes.hasOwnProperty(themeName)
   }

   getLayoutThemes() {
      return this.layoutThemes
   }

   getCurrentLayoutThemeName() {
      return this.layoutThemeName
   }

   getCurrentLayoutTheme() {
      return this.getLayoutTheme(this.layoutThemeName)
   }

   clearCurrentLayoutTheme() {
      this.renderer.removeClass(document.body, 'theme-' + this.layoutThemeName)

      this.spinnerType = this.spinnerTypes[0]
   }

   applyLayoutTheme(themeName: string) {
      if (this.layoutThemeName == themeName) return

      if (this.hasLayoutTheme(themeName)) {
         this.layoutThemeName = themeName

         this.renderer.addClass(document.body, 'theme-' + this.layoutThemeName)

         let theme = this.getLayoutTheme(themeName)
         if (theme?.spinnerType && this.spinnerTypes.includes(theme.spinnerType)) {
            this.spinnerType = theme.spinnerType
         }

         return true
      } else {
         this.defaultLayoutTheme()
      }

      return false
   }

   defaultLayoutTheme() {
      if (this.console) console.log(this.logPrefix, '- defaultLayoutTheme')

      this.applyLayoutTheme('DEFAULT')
   }

   //-- Spinner --//

   spinnerShow() {
      this.spinReqShow++;

      //if(this.console) console.log( this.logPrefix,  '- spinnerShow spinReqShow', this.spinReqShow);

      if(this.spinReqShow == 1){

          //if(this.console) console.log( this.logPrefix,  '- spinnerShow - OPEN');

          if(this.spinnerType == 'PNO'){

              this.spinner = this.dialog.open(SpinnerPNOComponent, {
                  panelClass: 'app-spinner',
                  disableClose: true,
                  backdropClass: 'app-spinner-overlay'
              });
          }
          else if(this.spinnerType == 'B4R'){

              this.spinner = this.dialog.open(SpinnerB4RComponent, {
                  panelClass: 'app-spinner',
                  disableClose: true,
                  backdropClass: 'app-spinner-overlay'
              });
          }
          else if(this.spinnerType == 'SHYPS'){

              this.spinner = this.dialog.open(SpinnerSHYPSComponent, {
                panelClass: 'app-spinner',
                disableClose: true,
                backdropClass: 'app-spinner-overlay'
              });
          }
          else if(this.spinnerType == 'BINS'){

            this.spinner = this.dialog.open(SpinnerBINSComponent, {
              panelClass: 'app-spinner',
              disableClose: true,
              backdropClass: 'app-spinner-overlay'
            });
          }
      }

      this.spinnerRefresh()
   }

   spinnerHide() {
      this.spinReqClose++

      this.spinnerRefresh()
   }

   spinnerRefresh() {
      if (this.spinner && this.spinner.hasOwnProperty('componentInstance') && this.spinner.componentInstance != null) {
         let spinReqCurr: any = this.spinReqShow - this.spinReqClose
         spinReqCurr = parseInt(spinReqCurr)

         if (spinReqCurr <= 0) {
            this.spinner.close()

            this.spinReqShow = 0
            this.spinReqClose = 0
         }
      }
   }
}

